import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const patientNoteApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPatientNotes: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `patient_note/?${qs}`;
      },
      providesTags: ['PatientNote'],
    }),
    createPatientNote: builder.mutation({
      query: body => ({
        url: 'patient_note/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['PatientNote'],
    }),
    updatePatientNote: builder.mutation({
      query: ({ id, body }) => ({
        url: `patient_note/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['PatientNote'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPatientNotesQuery,
  useCreatePatientNoteMutation,
  useUpdatePatientNoteMutation,
} = patientNoteApi;
